<div class="container">
    <h1 class="principal-title">Encuentros prospectivos</h1>
    <br>
    <ng-container *ngIf="newsFlag===1">
        <div class="row">
            <div class="col-sm-12" *ngIf="e">
                <h1 id="br-title" class="news-title">{{ e.title }}</h1>
            </div>
        </div>
    </ng-container>
    <div class="row mb-3">
        <ng-container *ngIf="newsFlag!==1">
            <div class="col-sm-1"></div>
        </ng-container>
        <ng-container *ngIf="e">
            <div style="text-align: center;" [class]="newsFlag===1 ? 'col-md-9 col-sm-12':'col-md-10 col-sm-12'">
                <ng-container *ngIf="newsFlag===0">
                    <h1 id="br-title" class="news-title">{{ e.title }}</h1>
                </ng-container>
                <ng-container *ngIf="e.img.substr(1,6)==='upload'">
                    <img class="img-fluid img-meet mx-auto" src="{{URL}}{{e.img}}" alt="e.title">
                </ng-container>
                <ng-container *ngIf="e.img.substr(1,6)!=='upload'">
                    <img class="img-fluid img-meet mx-auto" src="{{e.img}}" alt="e.title">
                </ng-container>
                <div class="row">
                    <div class="news-date col-6">{{ e.date | date:'dd/MM/yy' }}</div>
                    <div class="news-autor col-6">{{ e.autor }}</div>
                </div>
                <div *ngFor="let o of cn">
                    <div class="news-content" *ngIf="e.id == +o.idnews" [innerHTML]="o.content"></div>
                </div>
                <div class="text-end">
                    <a class="underline" href="{{e.source}}" target="_blank">Ir al enlace original</a>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="newsFlag===0">
            <div class="col-sm-1"></div>
        </ng-container>
        <!-- Inicia sección encuentros similares -->
        <ng-container *ngIf="newsFlag===1">
    <div class="col-md-3 col-sm-12 mt-1">
        <!-- Sección de Videos Embed -->
        <div *ngIf="getValidUrls(e?.urls).length > 0" class="mb-4">
            <div class="title-related-news">Videos relacionados</div>
            <div class="video-container" *ngFor="let url of e.urls">
                <div class="embed-responsive embed-responsive-16by9 mb-3 card mb-2 mt-2">
                    <iframe class="embed-responsive-item"
                            [src]="getSafeUrl(url)"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                </div>
            </div>
        </div>

        <!-- Sección de Documentos PDF -->
        <div *ngIf="e?.doc?.length > 0" class="mb-4">
            <div class="title-related-news">Documentos relacionados</div>
            <div class="documents-list">
                <div *ngFor="let name of e.doc_name; let i = index" class="document-item">
                    <a [href]="e.doc[i].startsWith('/uploads') ? URL + e.doc[i] : e.doc[i]"
                       target="_blank"
                       class="document-link">
                        <i class="fa fa-file-pdf-o" style="color: #F08080 ;"></i>
                        <span class="document-name underline related-new-title"> &nbsp; {{name || e.doc[i].split('/').pop()}}</span>
                    </a>
                </div>
            </div>
        </div>

        <!-- Eventos relacionados (existente) -->
        <div class="title-related-news">Eventos relacionados</div>
        <ng-container *ngFor="let new of news; let i=index">
            <ng-container *ngIf="i>0">
                <div class="card mb-2 mt-2" style="width: auto;">
                    <ng-container *ngIf="new.img.substr(1,6)==='upload'">
                        <img class="card-img-top" src="{{URL}}{{new.img}}" alt="image">
                    </ng-container>
                    <ng-container *ngIf="new.img.substr(1,6)!=='upload'">
                        <img class="card-img-top" src="{{new.img}}" alt="image">
                    </ng-container>
                    <div class="card-body">
                        <a class="underline related-new-title" routerLink="../{{new.id}}" (click)="changeNew(new.id)">
                            <p style="text-align: left; font-weight: 300;">{{new.title}}</p>
                        </a>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</ng-container>
        <!-- Términa sección noticias similares -->

        <br>
    </div>
    <hr>
    <h2 class="news-title">Más encuentros</h2>
    <div *ngFor="let o of ns|paginate:{itemsPerPage:10, currentPage:pages}; let i = index">
        <div class="row row-other-news" routerLink="../{{o.id}}" (click)="changeNew(o.id)">
            <div class="col-sm-2 col-5">
                <ng-container *ngIf="o.img.substr(1,6)==='upload'">
                    <img class="img-fluid  img-other" src="{{URL}}{{ o.img }}" alt="">
                </ng-container>
                <ng-container *ngIf="o.img.substr(1,6)!=='upload'">
                    <img class="img-fluid  img-other" src="{{ o.img }}" alt="">
                </ng-container>
            </div>
            <div class="col-sm-10 col-7">
                <a class="underline other-news-title" routerLink="../{{o.id}}" (click)="changeNew(o.id)">{{ o.title
                    }}</a>
                <div class="d-none d-sm-block">
                    <div class="news-content-mini">{{ limitWords(o.content) }}</div>
                </div>
                <div class="news-date">{{ o.date | date:'dd/MM/yy' }}</div>
            </div>
            <br>
            <!-- <hr> No se muestra en el observatorio-->
        </div>
        <br>
    </div>
    <pagination-controls (pageChange)="pages = $event" previousLabel="Anterior" nextLabel="Siguiente">
    </pagination-controls>
</div>
